import React, { useCallback, useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

// img
import avatarImg from "../../../assets/png/avatar.png";
import mailIcon from "../../../assets/svg/contact/ic-mail.svg";
import phoneIcon from "../../../assets/svg/contact/ic-phone.svg";
import resetIcon from "../../../assets/svg/action/ic-reset.svg";

// Jds
import {
  Text,
  Container,
  SearchBox,
  Button,
  Card,
  Avatar,
  BadgeV2,
  ListBlock,
  Icon,
  Image,
  Notifications,
  ActionButton,
  AvatarV2,
  Tooltip,
  InputCheckbox,
} from "@jds/core";

// Mui
import { Box } from "@mui/material";
import IconLabel from "../IconLabel";
import JdsModal from "../JdsModal";
import {
  addParamsURL,
  baseToImg,
  downloadFile,
  fileToBase,
  makeZipImages,
} from "../../../util/helper";
import AvatarUpload from "../Form/avatarUpload/AvatarUpload";
import useApiHttp from "../../../hooks/use-http";
import FsLightbox from "fslightbox-react";
import EmptyState from "../../NoData/EmptyState";
import Loader from "../Loader/Loader";
import GridContainer from "../../Layout/GridContainer";
import { useDispatch } from "react-redux";
import { uploadPhotosActions } from "../../../store/state-slices/photosUpload";
import decryptUrl from "../../../util/img-decryption";
import EditPhotographerForm from "../Form/EditPhotographerForm";

export default function PhotographerCard(props) {
  const role = props?.role || "GUEST";
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id: eventId } = useParams();
  const data = props?.data || {};
  const hasCustomField = props?.hasCustomField;
  const { sendRequest: updateInvitePrf, isLoading: isUpdateInvitePrf } =
    useApiHttp();
  const id = data?.id;
  // const profilePic = data?.profilePictureThumbnail
  //   ? baseToImg(data?.profilePictureThmbnail)
  //   : null;
  const profilePic = data?.profilePictureThumbnailUrl
    ? data?.profilePictureThumbnailUrl
    : null;
  const status = data?.registerStatus || "NULL";
  const isRegistered = status == "REGISTERED";
  const isInvited = status == "NULL";
  const isApproved = status == "APPROVED";
  const isDenied = status == "DENIED";
  const isBlocked = data?.isBlocked;
  const firstName = data.firstName || "";
  const lastName = data.lastName || "";
  const guestName = firstName + " " + lastName;
  const contactNum = data?.phoneNumber;

  const handleUpdateInvitePrf = (img, file) => {
    const guestProfile = new FormData();
    guestProfile.append("userId", data?.id);
    guestProfile.append("profilePicture", file);
    guestProfile.append("firstName", "firstname");
    guestProfile.append("lastName", "lastname");
    guestProfile.append("role", role);

    updateInvitePrf(
      {
        // base: "AUTH",
        url: `event-attendee/guest/profile-image`,
        method: "PUT",
        body: guestProfile,
        formData: true,
      },
      null,
      (data) => {
        props?.profileUpdate();
        Notifications.toast.success({
          id: "guest-profile-update",
          title: data?.message,
        });
      },
      (err, data) => {
        Notifications.toast.error({
          id: "guest-profile-update",
          title: data?.message,
        });
      }
    );
  };
  return (
    <div
      style={{
        borderRadius: "10px",
        boxShadow: " 0px 4px 16px 0px #00000014",
      }}
    >
      <Box sx={{ position: "relative" }}>
        <Box
          p={"32px 16px 16px 16px"}
          textAlign="center"
          sx={{
            width: "100%",
            // height: data?.email ? "" : "191.91px"
          }}
        >
          <Container
            fullWidth
            horizontalAlign="center"
            style={{
              marginBottom: "24px",
              marginTop: "40px",
            }}
          >
            <Text text={guestName} appearance="body-s-bold" />
          </Container>
          <Container
            fullWidth
            direction="column"
            gap={8}
            horizontalAlign="center"
          >
            {data?.email && (
              <IconLabel
                src={mailIcon}
                text={<Text text={data.email} color="primary_grey_80" />}
              />
            )}

            <IconLabel
              src={phoneIcon}
              text={<Text text={contactNum} color="primary_grey_80" />}
            />
          </Container>
          <Container
            fullWidth
            verticalAlign="center"
            horizontalAlign="center"
            gap={16}
            style={{
              marginTop: (isRegistered || isDenied || isBlocked) && "40px",
            }}
          >
            {isDenied && (
              <Button
                // iconLeft={<img src={resetIcon} alt="grid icon" />}
                iconLeft={"IcReset"}
                label="Restore"
                kind="secondary"
                size="medium"
                fullWidth
                onClick={() => props?.action && props.action("1", id)}
              />
            )}
            {isBlocked && (
              <Button
                // iconLeft={<img src={resetIcon} alt="grid icon" />}
                iconLeft={"IcReset"}
                label="Unblock"
                kind="secondary"
                size="medium"
                fullWidth
                onClick={() => props?.restoreAction && props.restoreAction(id)}
              />
            )}
          </Container>
        </Box>

        <Box
          textAlign="center"
          sx={{
            position: "absolute",
            top: isRegistered || isDenied || isBlocked ? "-90px" : "-60px",
            left: "50%",
            transform: "translateX(-50%)",
          }}
        >
          {isBlocked ? (
            <AvatarV2
              size="xtra-xtra-large"
              kind="information"
              avatarKind={profilePic ? "image" : null}
              image={addParamsURL(profilePic, { size: "s" }) || ""}
              badgeLabel={"Blocked"}
              informationBadgeColor={"negative"}
              informationBadgeKind={"label"}
              informationBadgePlacement={"bottom-center"}
              onClick={() => {
                if (profilePic) {
                  props.setIsFaceModalClose(false);
                }
              }}
            />
          ) : isInvited || isRegistered ? (
            <AvatarUpload
              id={id}
              accept=".png ,.jpg ,.jpeg"
              image={
                data?.profileFile
                  ? URL.createObjectURL(data?.profileFile)
                  : profilePic
                    ? addParamsURL(profilePic, { size: "s" })
                    : ""
              }
              fileValue={(file) => {
                fileToBase(file)
                  .then((base64Value) => {
                    handleUpdateInvitePrf(base64Value, file);
                  })
                  .catch((error) => { });
              }}
              clearFileBlob={props.clearFileBlob}
              badgeActionIcon={true}
              kind="default"
              iconProps={{
                ic: "IcEditPen",
                onClick: () => {
                  props?.setIsEditPhotographerModalClose(false);
                },
              }}
              onClick={() => {
                if (profilePic) {
                  props.setIsFaceModalClose(false);
                }
                // navigate(`/home/events/faces/${eventId}`, {
                //   state: { guestId: id },
                // });
              }}
            />
          ) : isApproved ? (
            <AvatarUpload
              id={id}
              accept=".png ,.jpg ,.jpeg"
              image={
                data?.profileFile
                  ? URL.createObjectURL(data?.profileFile)
                  : profilePic
                    ? addParamsURL(profilePic, { size: "s" })
                    : ""
              }
              fileValue={(file) => {
                fileToBase(file)
                  .then((base64Value) => {
                    handleUpdateInvitePrf(base64Value, file);
                  })
                  .catch((error) => { });
              }}
              clearFileBlob={props.clearFileBlob}
              badgeActionIcon={true}
              onClick={() => {
                if (profilePic) {
                  props.setIsFaceModalClose(false);
                }
              }}
              kind="information"
              badgeLabel={"Approved"}
              informationBadgeColor={"positive"}
              informationBadgeKind={"label"}
              informationBadgePlacement={"bottom-center"}
              iconProps={{
                ic: "IcEditPen",
                onClick: () => {
                  props?.setIsEditPhotographerModalClose(false);
                },
              }}
            />
          ) : (
            <AvatarV2
              size="xtra-xtra-large"
              kind="information"
              image={
                profilePic ? addParamsURL(profilePic, { size: "s" }) || "" : ""
              }
              badgeLabel={isApproved ? "Approved" : "Denied"}
              informationBadgeColor={isApproved ? "positive" : "negative"}
              informationBadgeKind={"label"}
              informationBadgePlacement={"bottom-center"}
              onClick={() => {
                if (profilePic) {
                  props.setIsFaceModalClose(false);
                }
              }}
            />
          )}

          {/* {(isApproved || isDenied) && (
            <Container
              fullWidth
              horizontalAlign="center"
              style={{ transform: "translateY(-70%)" }}
            >
              <BadgeV2
                label={isApproved ? "Approved" : "Denied"}
                color={isApproved ? "positive" : "negative"}
                appearance="subtle"
              />
            </Container>
          )} */}
        </Box>
      </Box>
      {/* {previewImgArr.length ? (
        <FsLightbox
          disableLocalStorage={true}
          toggler={lightboxController.toggler}
          sources={previewImgArr}
          slide={lightboxController.slide}
          key={previewImgArr.length}
          onClose={() => {
          }}
        />
      ) : null} */}
    </div>
  );
}

const PhotoInDiv = ({
  item,
  eventId,
  setLightboxController,
  setModalUsername,
  getFaceListHandler,
  setPreviewImgArr,
  setPage,
  page,
  setClusterId,
  setFaceList,
}) => {
  const [scalingFactor, setScalingFactor] = useState(0);
  const [faceDetection, setFaceDetection] = useState(false);
  const [faceDiv, setFaceDiv] = useState([]);
  const { sendRequest: faceDetectionApi, isLoading: isFaceDetectionLoading } =
    useApiHttp();
  const { sendRequest: downloadRequest } = useApiHttp();

  const faceDetectionHandle = (value) => {
    faceDetectionApi(
      {
        url: `face/show-detected-faces?eventId=${eventId}&mediaId=${value}`,
        method: "GET",
        base: "MEDIA",
      },
      null,
      (data) => {
        setFaceDiv(data?.data);
      }
    );
  };

  const downloadImg = (index = 0, isMultiple = false, fileUrl = "") => {
    const formData = new FormData();
    formData.append("imageUrl", fileUrl);
    formData.append("eventId", eventId);
    return new Promise((resolve, reject) => {
      downloadRequest(
        {
          url: `organizer/download`,
          method: "POST",
          base: "MEDIA",
          formData: true,
          body: formData,
        },
        null,
        (data) => {
          const imageUrl = URL?.createObjectURL(data);
          if (!isMultiple) {
            downloadFile(imageUrl, "image");
            Notifications?.toast?.success("Image Downloaded");
          } else {
            // dispatch(uploadPhotosActions.setUploadCount(index + 1));
            resolve(data); // Resolve the Promise with the imageUrl
          }
        },
        (err, data) => {
          Notifications?.toast?.error({
            id: "download-photos-error",
            title: data?.message,
          });
          reject(err);
        }
      );
    });
  };

  const imgRef = useRef(null);
  return (
    <>
      <img
        ref={imgRef}
        // src={item?.reducedFileSignedPath}
        src={decryptUrl(item?.reducedFileSignedPath)}
        style={
          {
            // height: "auto !important",
            // maxHeight: "80vh !important",
            // maxWidth: "50vw",
            // width: "auto !important",
          }
        }
      />

      <div
        style={{
          position: "absolute",
          bottom: "15px",
          width: "100%",
          // minWidth: "500px",
          display: "flex",
          justifyContent: "center",
          gap: "20px",
          marginTop: "10px",
          whiteSpace: "nowrap",
        }}
      >
        <ActionButton
          label={`${faceDetection ? "Hide" : "Show detected faces"}`}
          kind="secondary"
          appearance="contrast"
          onClick={(e) => {
            e.stopPropagation();
            faceDetectionHandle(item?.mediaId);
            const originalWidth = imgRef?.current?.naturalWidth;
            const originalHeight = imgRef?.current?.naturalHeight;
            const scalingFactor = Math.min(
              imgRef?.current?.offsetWidth
                ? imgRef?.current?.offsetWidth / originalWidth
                : 0,
              imgRef?.current?.offsetHeight
                ? imgRef?.current?.offsetHeight / originalHeight
                : 0
            );
            setScalingFactor(scalingFactor);

            setFaceDetection((pre) => !pre);
          }}
        />
        <ActionButton
          kind="secondary"
          icon={"IcDownload"}
          label="Download"
          appearance="contrast"
          onClick={(e) => {
            // e.stopPropagation();

            downloadImg(undefined, undefined, item?.originalFileSignedPath);
          }}
        />
      </div>
      {faceDiv?.map((divItem) => (
        <div
          onClick={(e) => {
            e.stopPropagation();
            // window.location.reload();
            // document.body.style.overflow = "";
            // document.documentElement.style.overflow = "";
            // // Remove fslightbox applied styles
            // document.body.classList.remove("fslightbox-open");
            // const fslightbox = document.querySelector(".fslightbox-container");
            // if (fslightbox) {
            //   fslightbox.style.overflow = "";
            // }

            const closeBtn = document.querySelector(
              'div.fslightbox-toolbar-button[title="Close"]'
            );
            closeBtn.click();
            // setLightboxController((pre) => {
            //   return {
            //     ...pre,
            //     toggler: false,
            //     slide: 1,
            //   };
            // });
            if (divItem?.clusterId !== item?.clusterId) {
              setPreviewImgArr([]);
              setFaceList([]);
              setClusterId(divItem?.clusterId);
              setPage(0);
              setModalUsername(divItem?.username);
            }
          }}
          key={divItem?.clusterId}
          className="rectangle"
          style={{
            display: faceDetection ? "block" : "none",
            position: "absolute",
            left: divItem?.xcoordinate * scalingFactor,
            top: divItem?.ycoordinate * scalingFactor,
            width: divItem?.imageWidth * scalingFactor,
            height: divItem?.imageHeight * scalingFactor,
            border: "2px solid #00ff00",
            cursor: "pointer",
            borderRadius: "1px",
          }}
        />
      ))}
    </>
  );
};
